/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_PurchasingInputs */

const en_nav_section_purchasing = /** @type {(inputs: Nav_Section_PurchasingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchasing`)
};

/**
* | output |
* | --- |
* | "Purchasing" |
*
* @param {Nav_Section_PurchasingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_purchasing = /** @type {((inputs?: Nav_Section_PurchasingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_PurchasingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_purchasing(inputs)
});